// extracted by mini-css-extract-plugin
export var checkbox = "_24-0";
export var circle = "_24-3";
export var horizontalContainer = "_24-7";
export var sm = "_24-5";
export var switch0 = "_24-2";
export var switchDisabled = "_24-8";
export var switchEnabled = "_24-1";
export var textSwitchContainer = "_24-9";
export var textSwitchOption = "_24-a";
export var textSwitchOptionSelected = "_24-b";
export var verticalContainer = "_24-6";
export var xs = "_24-4";